(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bannieres-slides"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    document.querySelectorAll('[data-vbn]').forEach(function (root) {
      var track = root.querySelector('[data-vbn-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var dots = root.querySelectorAll('[data-vbn-dot]');
      if (!track || !slides.length) return;
      var index = 0;
      var timer = null;
      var userPaused = false;
      var delay = parseInt(root.dataset.autoplay, 10) * 1000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* La vidéo de la bannière visible repart du début ; les autres sont en pause */
      function playVideo(i) {
        slides.forEach(function (s, n) {
          var v = s.querySelector('[data-vbn-video]');
          if (!v) return;
          if (n === i && !root.hasAttribute('data-hold')) {
            try { v.currentTime = 0; } catch (e) {}
            if (reduce || userPaused) return;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else {
            v.pause();
          }
        });
      }
      function setActive(i) {
        if (i === index && slides[i].classList.contains('is-active')) return;
        index = i;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === i);
          var btn = s.querySelector('.vbn__btn');
          if (btn) btn.tabIndex = n === i ? 0 : -1;
        });
        dots.forEach(function (d, n) {
          if (n === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
        });
        playVideo(i);
      }
      function go(i) {
        var n = (i + slides.length) % slides.length;
        track.scrollTo({ left: n * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        setActive(n);
      }

      var prev = root.querySelector('[data-vbn-prev]');
      var next = root.querySelector('[data-vbn-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.dataset.vbnDot, 10)); start(); });
      });

      /* Glissement au doigt : on suit la bannière visible */
      var scrollEnd = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollEnd);
        scrollEnd = setTimeout(function () {
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        }, 90);
      }, { passive: true });

      /* Défilement automatique : une bannière avec vidéo passe à la suivante quand sa vidéo
         se termine ; sans vidéo, au bout du délai. En pause au survol, au focus, hors écran
         et tant que la section parente garde l'attente (data-hold) : la vidéo repart alors en boucle. */
      var visible = true;
      var paused = false;
      function blocked() { return reduce || !delay || paused || userPaused || touching || !visible || document.hidden || root.hasAttribute('data-hold'); }

      /* Bouton pause : arrête le défilement et la vidéo jusqu'à ce que le visiteur relance */
      var pauseBtn = root.querySelector('[data-vbn-pause]');
      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.classList.toggle('is-paused', userPaused);
        pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
        var v = slides[index].querySelector('[data-vbn-video]');
        if (userPaused) {
          stop();
          if (v) v.pause();
        } else {
          if (v && !reduce) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          start();
        }
      });

      /* Le trait de la bannière active se remplit au rythme de sa vidéo */
      (function progress() {
        var v = slides[index].querySelector('[data-vbn-video]');
        if (!reduce && v && v.duration && dots[index]) dots[index].style.setProperty('--p', Math.min(1, v.currentTime / v.duration).toFixed(3));
        window.requestAnimationFrame(progress);
      })();
      function stop() { clearTimeout(timer); timer = null; }
      function start() {
        stop();
        if (blocked()) return;
        var v = slides[index].querySelector('[data-vbn-video]');
        /* sécurité si la vidéo ne se lance pas (lecture automatique refusée) */
        var wait = v ? Math.max(delay, 9000) : delay;
        timer = setTimeout(function () { go(index + 1); start(); }, wait);
      }
      slides.forEach(function (s, n) {
        var v = s.querySelector('[data-vbn-video]');
        if (!v) return;
        v.addEventListener('ended', function () {
          if (n !== index) return;
          if (blocked()) {
            try { v.currentTime = 0; } catch (e) {}
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
            return;
          }
          go(index + 1);
          start();
        });
      });
      root.addEventListener('mouseenter', function () { paused = true; stop(); });
      root.addEventListener('mouseleave', function () { paused = false; start(); });
      root.addEventListener('focusin', function () { paused = true; stop(); });
      root.addEventListener('focusout', function () { paused = false; start(); });
      /* Doigt posé sur la bannière : rien ne bouge tout seul tant qu'il n'est pas levé */
      var touching = false;
      track.addEventListener('touchstart', function () { touching = true; stop(); }, { passive: true });
      track.addEventListener('touchend', function () { touching = false; start(); }, { passive: true });
      track.addEventListener('touchcancel', function () { touching = false; start(); }, { passive: true });
      document.addEventListener('visibilitychange', start);
      root.addEventListener('vbn:release', function () { playVideo(index); start(); });
      root.addEventListener('vbn:hold', stop);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          start();
        }, { threshold: 0.3 }).observe(root);
      }
      window.addEventListener('resize', function () {
        track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
      });
      /* Le navigateur peut restaurer le défilement horizontal au rechargement : on repart de la première bannière */
      track.scrollLeft = 0;
      playVideo(0);
      start();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motion"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* ── 1. Scroll reveal ─────────────────────────────── */
    var REVEAL = [
      '.vn-prod-card', '.product-card', '.bc-card', '.vn-blog-card',
      '.collection-card', '.vn-values__item', '.vn-coll-row',
      '.faq-item', '.ing-spot__stat'
    ];
    var els = document.querySelectorAll(REVEAL.join(','));
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var byParent = new Map();
    els.forEach(function (el) {
      /* Ce qui est déjà visible au chargement s'affiche immédiatement, sans fondu */
      if (el.getBoundingClientRect().top < vh) return;
      var p = el.parentElement;
      var i = byParent.get(p) || 0;
      byParent.set(p, i + 1);
      el.style.setProperty('--v-stagger', Math.min(i, 5));
      el.classList.add('v-reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-inview');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    document.querySelectorAll('.v-reveal').forEach(function (el) { io.observe(el); });

    /* Filet de sécurité : si un élément reste caché 3 s après son entrée
       potentielle (observer défaillant, onglet en arrière-plan…), on l'affiche. */
    setTimeout(function () {
      document.querySelectorAll('.v-reveal:not(.is-inview)').forEach(function (el) {
        if (el.getBoundingClientRect().top < (window.innerHeight || 0)) {
          el.classList.add('is-inview');
        }
      });
    }, 3000);

    /* ── 2. Animated counters (ingredient stats) ─────── */
    var counters = document.querySelectorAll('.ing-spot__stat-val');
    if (counters.length) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          cio.unobserve(e.target);
          var el = e.target;
          var m = el.textContent.match(/^(\d+)([\s\S]*)$/);
          if (!m) return;
          var target = parseInt(m[1], 10);
          var suffix = m[2];
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / 1100, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
